module.exports = __webpack_public_path__ + "media/dog-about/female-4e3f3ebe.svg";